import { useState } from "react";

function useForm(keys) {
  const [form, setForm] = useState(keys || {});

  const updateFormValue = (key, value) => {
    setForm({
      ...form,
      [key]: value,
    });
  };

  const updateFormValues = (obj) => {
    setForm({
      ...form,
      ...obj,
    });
  };

  function clearForm() {
    setForm({});
  }

  // const clearForm = (fields) => {
  //   const clearedFields = {
  //     ...[
  //       ...fields.map((field) => {
  //         // get field names
  //         return field?.field_name;
  //       }),
  //     ].reduce((acc, key) => {
  //       // return empty fields
  //       return { ...acc, [key]: null };
  //     }, {}),
  //   };
  //   setForm(clearedFields);
  // };

  const onChange = (event) => {
    // Get the name of the field that caused this change event
    // Get the new value of this field
    const { name, value, type } = event.target;

    // check if the field is int
    var newValue = type === "number" ? parseInt(value) : value;

    updateFormValue(name, newValue);
  };

  return {
    form,
    setForm,
    clearForm,
    updateFormValue,
    updateFormValues,
    onChange,
  };
}

export default useForm;
